const events = [
  {
    title: "Séjours et voyages",
    slug: "séjours",
    image:
      "/sejours.jpeg",
    description:
      "Sur mesure, l\'Afrique de l\'Ouest et Centrale à votre rythme.",
    details: `
        <h1 style="color:#888888; font-size:22px; font-weight:bold;">Voyages sur mesure :<h1> 
Le Sénégal et le Cameroun à votre image.

Laissez de côté les itinéraires prédéfinis et plongez au cœur de l'Afrique avec un voyage conçu exclusivement pour vous. Que vous rêviez d'une immersion culturelle au Sénégal ou d'une aventure safari au Cameroun, nous transformons vos envies en une expérience unique.

Nous organisons vos circuits de A à Z : des hébergements de charme aux activités authentiques en passant par les transports. Oubliez la logistique, et concentrez-vous sur la découverte et l'émerveillement.

<h1 style="font-style:italic;">Votre voyage commence ici. Remplissez le formulaire pour nous faire part de tous les détails (destinations, activités, type de prestations, etc.). Plus vous êtes précis, plus notre proposition sera parfaite.<h1>
    `,
  },
  {
    title: "Services et déplacements",
    slug: "services",
    image:
      "/services.jpeg",
    description:
      "Bougez en toute liberté.",
    details: `
        Pour que votre séjour soit aussi fluide que mémorable, nous avons pensé à chaque étape de votre mobilité. De votre arrivée à vos plus belles escapades, nos services de transport sont là pour vous garantir confort et flexibilité.

  <h1 style="color:#888888; font-size:22px; font-weight:bold;">Transferts & Taxi :<h1> Voyagez en toute sérénité depuis et vers les aéroports, ou lors de vos déplacements quotidiens. Nos chauffeurs professionnels vous garantissent un service fiable et ponctuel.

 <h1 style="color:#888888; font-size:22px; font-weight:bold;">Location de véhicules :<h1> Louez une voiture avec ou sans chauffeur pour explorer à votre rythme. Profitez d'une totale autonomie, ou laissez-vous guider par un expert local.

 <h1 style="color:#888888; font-size:22px; font-weight:bold;">Loisirs & Aventure :<h1> Pour une dose d'adrénaline, louez un jet ski, un scooter ou un quad et partez à la découverte des paysages côtiers ou des sentiers de terre battue.
    `,
  },
  {
    title: "Animation et activités",
    slug: "animations",
    image:
      "/animations.jpeg",
    description:
      "Plongez au cœur de l'expérience.",
    details: `
        Ne vous contentez pas de visiter, vivez ! Nous vous proposons une sélection d'activités pour enrichir votre séjour et vous faire découvrir l'authenticité de l'Afrique.

 <h1 style="color:#888888; font-size:22px; font-weight:bold;">Immersion culturelle :<h1> Suivez un guide local passionné qui vous révélera les secrets de l'histoire et des traditions. Explorez les marchés animés, les villages typiques et les sites historiques pour une expérience humaine et riche en émotions.

<h1 style="color:#888888; font-size:22px; font-weight:bold;">Excursions :<h1> Préparez-vous pour l'aventure ! Que ce soit à bord d'un quad à travers la brousse ou d'un jet ski sur les eaux turquoise, nos excursions sont conçues pour les amateurs de sensations fortes et les explorateurs.

 <h1 style="color:#888888; font-size:22px; font-weight:bold;">Détente :<h1> Après l'effort, le réconfort. Accordez-vous une pause sur les plus belles plages de la région pour des moments de pure relaxation.
    `,
  },
];

export default events;
